export default __webpack_public_path__ + "static/media/pic108.6c8190d2.jpg";